// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.inverter-control {
    display: flex;
    flex-direction: row;
    gap:40px;
    padding: 20px;
  }
  
  h4 {
    font-size: 1.5rem;
    font-weight: 500;
    color: #333;
  }
  
  
  .inverter-list {
    width: 30%;
    padding: 20px;
    background-color: #f4f4f9;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .inverter-list h3 {
    font-size: 1.2rem;
    margin-bottom: 15px;
    color: #3909e4;
    text-align: left;
  }
  
  .inverter-item {
    display: flex;
    gap:10px;
    align-items: center;
    margin-bottom: 10px;
  }
  /* .inverter-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 20px;
  } */
  .inverter-item img {
    width: 200px; 
    height: 50px; 
    margin-top: 10px; 
    border-radius: 5px; 
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); 
  }
  .select-btn {
    padding: 10px;
    background-color: #3909e4;
    color: white;
    font-size: 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  .select-btn:hover {
    background-color: #5c0cd1;
  }
  
  .button-group {
    display: inline-flex; /* Ensures the buttons are displayed inline */
    align-items: center; /* Vertically align buttons if they have different heights */
    gap: 10px; /* Adds spacing between buttons */
  }
  
  .status-btn {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .status-btn.off {
    background-color: #dc3545; /* Red for Off status */
  }
  
  .status-btn:hover {
    opacity: 0.9; /* Add hover effect */
  }
  
  .active-power-btn {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 8px 16px;
    font-size: 1rem;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .active-power-btn:hover {
    opacity: 0.9; 
  }
  
  
  .inverter-list p {
    color: #777;
    font-size: 1rem;
  }
  
  
  .inverter-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  .makesure {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    width: 300px;
  }
  
  .makesure p {
    font-size: 1rem;
    margin-bottom: 20px;
  }
  
  .makesure button {
    padding: 8px 20px;
    font-size: 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 10px;
  }
  
  .makesure button:hover {
    opacity: 0.8;
  }
  
  .makesure button:nth-child(1) {
    background-color: #4caf50;
    color: white;
  }
  
  .makesure button:nth-child(2) {
    background-color: #f44336;
    color: white;
  }
  
  
    .inverter-details {
      padding: 20px;
      font-family: 'Arial', sans-serif;
    }
    
    .section {
      margin-bottom: 30px;
    }
    
    .section h3 {
      color: #1f2021;
      font-size: 1.2rem;
      margin-bottom: 15px;
      font-weight: bolder;
    }
    
    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 15px;
      background-color: #f9f9f9;
      padding: 20px;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
    
    .info-item {
      display: flex;
      gap: 12px;
      font-size: 1rem;
      color: #3909e4;
    }
    
    .info-item strong {
      color: #555;
    }
    
    .info-item:hover {
      background-color: #b9e0f2;
      border-radius: 4px;
      padding: 5px;
    }
  
   
    
    .active-power-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    .modal-contents {
      background-color: white;
      padding: 20px;
      border-radius: 8px;
      width: 400px;
      text-align: center;
    }
    
    .modal-contents .info-item {
      margin: 10px 0;
    }
    
    .modal-contents input {
      padding: 5px;
      width: 100px;
    }
    
    .active-button {
      display: flex; 
      justify-content: flex-end; 
      gap: 10px; 
      margin-top: 20px; 
    }
    
    .active-button button {
      padding: 8px 16px; 
      font-size: 1rem;
      border: none; 
      border-radius: 4px; 
      cursor: pointer; 
      transition: background-color 0.3s ease, color 0.3s ease;
    }
    
    .active-button button:first-child {
      background-color: #28a745; 
      color: white;
    }
    
    .active-button button:first-child:hover {
      background-color: #218838; 
    }
    
    .active-button button:last-child {
      background-color: #dc3545; 
      color: white;
    }
    
    .active-button button:last-child:hover {
      background-color: #c82333; 
    }
    
    
    button:hover {
      background-color: #2907b2;
    }
    `, "",{"version":3,"sources":["webpack://./src/components/RemoteControl/InverterControl.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;;EAGA;IACE,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,mBAAmB;EACrB;EACA;;;;;KAKG;EACH;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,wCAAwC;EAC1C;EACA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB,EAAE,6CAA6C;IACnE,mBAAmB,EAAE,4DAA4D;IACjF,SAAS,EAAE,iCAAiC;EAC9C;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,yBAAyB,EAAE,uBAAuB;EACpD;;EAEA;IACE,YAAY,EAAE,qBAAqB;EACrC;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,WAAW;IACX,eAAe;EACjB;;;EAGA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;;IAGE;MACE,aAAa;MACb,gCAAgC;IAClC;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,cAAc;MACd,iBAAiB;MACjB,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,SAAS;MACT,yBAAyB;MACzB,aAAa;MACb,kBAAkB;MAClB,wCAAwC;IAC1C;;IAEA;MACE,aAAa;MACb,SAAS;MACT,eAAe;MACf,cAAc;IAChB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,yBAAyB;MACzB,kBAAkB;MAClB,YAAY;IACd;;;;IAIA;MACE,eAAe;MACf,MAAM;MACN,OAAO;MACP,QAAQ;MACR,SAAS;MACT,oCAAoC;MACpC,aAAa;MACb,uBAAuB;MACvB,mBAAmB;IACrB;;IAEA;MACE,uBAAuB;MACvB,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,YAAY;MACZ,YAAY;IACd;;IAEA;MACE,aAAa;MACb,yBAAyB;MACzB,SAAS;MACT,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,YAAY;MACZ,kBAAkB;MAClB,eAAe;MACf,uDAAuD;IACzD;;IAEA;MACE,yBAAyB;MACzB,YAAY;IACd;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;MACzB,YAAY;IACd;;IAEA;MACE,yBAAyB;IAC3B;;;IAGA;MACE,yBAAyB;IAC3B","sourcesContent":["\r\n.inverter-control {\r\n    display: flex;\r\n    flex-direction: row;\r\n    gap:40px;\r\n    padding: 20px;\r\n  }\r\n  \r\n  h4 {\r\n    font-size: 1.5rem;\r\n    font-weight: 500;\r\n    color: #333;\r\n  }\r\n  \r\n  \r\n  .inverter-list {\r\n    width: 30%;\r\n    padding: 20px;\r\n    background-color: #f4f4f9;\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\r\n  }\r\n  \r\n  .inverter-list h3 {\r\n    font-size: 1.2rem;\r\n    margin-bottom: 15px;\r\n    color: #3909e4;\r\n    text-align: left;\r\n  }\r\n  \r\n  .inverter-item {\r\n    display: flex;\r\n    gap:10px;\r\n    align-items: center;\r\n    margin-bottom: 10px;\r\n  }\r\n  /* .inverter-item {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n  } */\r\n  .inverter-item img {\r\n    width: 200px; \r\n    height: 50px; \r\n    margin-top: 10px; \r\n    border-radius: 5px; \r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); \r\n  }\r\n  .select-btn {\r\n    padding: 10px;\r\n    background-color: #3909e4;\r\n    color: white;\r\n    font-size: 1rem;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s ease;\r\n  }\r\n  \r\n  .select-btn:hover {\r\n    background-color: #5c0cd1;\r\n  }\r\n  \r\n  .button-group {\r\n    display: inline-flex; /* Ensures the buttons are displayed inline */\r\n    align-items: center; /* Vertically align buttons if they have different heights */\r\n    gap: 10px; /* Adds spacing between buttons */\r\n  }\r\n  \r\n  .status-btn {\r\n    background-color: #28a745;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .status-btn.off {\r\n    background-color: #dc3545; /* Red for Off status */\r\n  }\r\n  \r\n  .status-btn:hover {\r\n    opacity: 0.9; /* Add hover effect */\r\n  }\r\n  \r\n  .active-power-btn {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n    padding: 8px 16px;\r\n    font-size: 1rem;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n  }\r\n  \r\n  .active-power-btn:hover {\r\n    opacity: 0.9; \r\n  }\r\n  \r\n  \r\n  .inverter-list p {\r\n    color: #777;\r\n    font-size: 1rem;\r\n  }\r\n  \r\n  \r\n  .inverter-modal {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .makesure {\r\n    background-color: white;\r\n    padding: 20px;\r\n    border-radius: 8px;\r\n    text-align: center;\r\n    width: 300px;\r\n  }\r\n  \r\n  .makesure p {\r\n    font-size: 1rem;\r\n    margin-bottom: 20px;\r\n  }\r\n  \r\n  .makesure button {\r\n    padding: 8px 20px;\r\n    font-size: 1rem;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin: 0 10px;\r\n  }\r\n  \r\n  .makesure button:hover {\r\n    opacity: 0.8;\r\n  }\r\n  \r\n  .makesure button:nth-child(1) {\r\n    background-color: #4caf50;\r\n    color: white;\r\n  }\r\n  \r\n  .makesure button:nth-child(2) {\r\n    background-color: #f44336;\r\n    color: white;\r\n  }\r\n  \r\n  \r\n    .inverter-details {\r\n      padding: 20px;\r\n      font-family: 'Arial', sans-serif;\r\n    }\r\n    \r\n    .section {\r\n      margin-bottom: 30px;\r\n    }\r\n    \r\n    .section h3 {\r\n      color: #1f2021;\r\n      font-size: 1.2rem;\r\n      margin-bottom: 15px;\r\n      font-weight: bolder;\r\n    }\r\n    \r\n    .info-grid {\r\n      display: grid;\r\n      grid-template-columns: 1fr 1fr;\r\n      gap: 15px;\r\n      background-color: #f9f9f9;\r\n      padding: 20px;\r\n      border-radius: 8px;\r\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n    }\r\n    \r\n    .info-item {\r\n      display: flex;\r\n      gap: 12px;\r\n      font-size: 1rem;\r\n      color: #3909e4;\r\n    }\r\n    \r\n    .info-item strong {\r\n      color: #555;\r\n    }\r\n    \r\n    .info-item:hover {\r\n      background-color: #b9e0f2;\r\n      border-radius: 4px;\r\n      padding: 5px;\r\n    }\r\n  \r\n   \r\n    \r\n    .active-power-modal {\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      background-color: rgba(0, 0, 0, 0.5);\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n    }\r\n    \r\n    .modal-contents {\r\n      background-color: white;\r\n      padding: 20px;\r\n      border-radius: 8px;\r\n      width: 400px;\r\n      text-align: center;\r\n    }\r\n    \r\n    .modal-contents .info-item {\r\n      margin: 10px 0;\r\n    }\r\n    \r\n    .modal-contents input {\r\n      padding: 5px;\r\n      width: 100px;\r\n    }\r\n    \r\n    .active-button {\r\n      display: flex; \r\n      justify-content: flex-end; \r\n      gap: 10px; \r\n      margin-top: 20px; \r\n    }\r\n    \r\n    .active-button button {\r\n      padding: 8px 16px; \r\n      font-size: 1rem;\r\n      border: none; \r\n      border-radius: 4px; \r\n      cursor: pointer; \r\n      transition: background-color 0.3s ease, color 0.3s ease;\r\n    }\r\n    \r\n    .active-button button:first-child {\r\n      background-color: #28a745; \r\n      color: white;\r\n    }\r\n    \r\n    .active-button button:first-child:hover {\r\n      background-color: #218838; \r\n    }\r\n    \r\n    .active-button button:last-child {\r\n      background-color: #dc3545; \r\n      color: white;\r\n    }\r\n    \r\n    .active-button button:last-child:hover {\r\n      background-color: #c82333; \r\n    }\r\n    \r\n    \r\n    button:hover {\r\n      background-color: #2907b2;\r\n    }\r\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
